import {SchemaFieldIfCallback} from '@/Types/SchemaField';
import GEFormFields from '@/Types/GEFormFields';

export default class IfCallbackResolverService {
    static resolve(ifCallbackString: string): SchemaFieldIfCallback | null {
        return (new this).resolveString(ifCallbackString);
    }

    public resolveString(ifCallbackString: string): SchemaFieldIfCallback | null {
        const [, type, params] = ifCallbackString.match(/(field):(.*)/i) || [];

        if (type === 'field') {
            const trimmedParams = params?.trim() ?? '';

            let field: string | undefined;
            let operator: string | undefined;
            let value: string | undefined;

            const lowerParams = trimmedParams.toLowerCase();
            const inIndex = lowerParams.indexOf(',in,');

            if (inIndex !== -1) {
                field = trimmedParams.slice(0, inIndex).trim();
                value = trimmedParams.slice(inIndex + 4).trim();
                operator = 'in';
            } else {
                const equalityMatch = trimmedParams.match(/^([a-z0-9_]+)([!=]=)(.+)$/i);
                if (equalityMatch) {
                    [, field, operator, value] = equalityMatch;
                }
            }

            if (!field || !operator) {
                console.warn(`IfCallbackResolverService: Unable to parse condition string: "${ifCallbackString}"`);
                return null;
            }

            return this.resolveField(field, operator, value);
        }

        return null;
    }

    private resolveField(field: string | undefined, operator: string | undefined, value: string | undefined): SchemaFieldIfCallback | null {
        if (field) {
            if (operator === 'in' && typeof value === 'string' && value.trim().length > 0) {
                return this.resolveIn(field, value);
            }

            if ((operator === '==' || operator == '!=') && value) {
                return this.resolveEquality(field, operator, value);
            }

        }

        return null;
    }

    private resolveEquality(field: string, operator: '==' | '!=', value: string): SchemaFieldIfCallback | null {
        if (operator === '==') {
            return (fields: GEFormFields) => fields[field] === value;
        }

        if (operator === '!=') {
            return (fields: GEFormFields) => fields[field] !== value;
        }

        return null;
    }

    private resolveIn(field: string, value: string): SchemaFieldIfCallback | null {
        try {
            const parsedValue = JSON.parse(value);
            if (!Array.isArray(parsedValue)) {
                console.error(`IfCallbackResolverService: Expected array for 'in' operator, got:`, parsedValue);
                return null;
            }
            return (fields: GEFormFields) => parsedValue.includes(fields[field]);
        } catch (error) {
            console.error(`IfCallbackResolverService: Failed to parse JSON value for 'in' operator. Field: "${field}", Value: "${value}"`, error);
            return null;
        }
    }
}
